export const LeadVertical = {
  OZEMPIC: "ozempic",
  TALCUM: "talcum powder",
  DUPIXENT: "dupixent",
  DEPO_PROVERA: "depoprovera",
  HERNIA_MESH: "hernia-mesh",
  SSDI: "SSDI",
  ROBLOX: "roblox-addiction",
  RIDESHARE: "rideshare",
  HAIR_RELAXER: "hair-relaxer",
  ROUNDUP: "roundup",
  SOCIAL_MEDIA_ADDICTION: "social-media-addiction",
  MOTOR_VEHICLE_ACCIDENTS: "motor-vehicle-accidents",
  SEXUAL_ABUSE: "sexual-abuse",
  MESOTHELIOMA : 'mesothelioma',
  TOXIC_BABY_FOOD: 'toxic-baby-food',
  PARAQUAT: 'paraquat',
  AFFF: 'afff',
  ULTRA_PROCESSED_FOOD: 'ultra-processed-food',
  OXBRYTA: 'oxbryta',
  PFAS: 'pfas',
  NEC: 'nec',
  BARD_POWERPORT: 'bard-powerport',
  SUBOXONE: 'suboxone',
  TESLA_AUTOPILOT_RECALL: 'tesla-autopilot-recall'
};


export const getVerticalFromCurrentPath = () => {
  if (typeof window === "undefined") return null;

  const path = window.location.pathname.toLowerCase();

  // Explicit / unique mappings first
  if (path.includes("sexual-abuse")) return "sexual-abuse";

  // Core verticals
  if (path.includes("ozempic")) return "ozempic";
  if (path.includes("talcum")) return "talcum powder";
  if (path.includes("dupixent")) return "dupixent";
  if (path.includes("depo-provera") || path.includes("depoprovera")) return "depoprovera";
  if (path.includes("hernia-mesh") || path.includes("transvaginal-mesh")) return "hernia-mesh";
  if (path.includes("ssdi")) return "SSDI";
  if (path.includes("hair-relaxer")) return "hair-relaxer";
  if (path.includes("roundup")) return "roundup";
  if (path.includes("social-media")) return "social-media-addiction";
  if (path.includes("motor-vehicle")) return "motor-vehicle-accidents";

  // Platform-specific
  if (path.includes("roblox")) return "roblox-addiction";
  if (path.includes("rideshare")) return "rideshare";

  // Additional verticals from routes
  if (path.includes("toxic-baby-food") || path.includes("baby-food")) return "toxic-baby-food";
  if (path.includes("paraquat")) return "paraquat";
  if (path.includes("afff")) return "afff";
  if (path.includes("ultra") || path.includes("ultraprocessed")) return "ultra-processed-food";
  if (path.includes("oxbryta")) return "oxbryta";
  if (path.includes("pfas")) return "pfas";
  if (path.includes("nec")) return "nec";
  if (path.includes("bard-powerport") || path.includes("powerport")) return "bard-powerport";
  if (path.includes("suboxone")) return "suboxone";
  if (path.includes("tesla-autopilot")) return "tesla-autopilot-recall";

  // Fallbacks
  if (path.includes("mesothelioma") || path.includes("meso")) return "mesothelioma";

  return 'general';
};